import {
  Button,
  Field,
  HStack,
  Input,
  Link,
  Stack,
  Text,
  InputGroup,
} from '@chakra-ui/react'
import { LuLock, LuMail } from 'react-icons/lu';
import { Link as RouterLink, Navigate } from 'react-router';
import PasswordInput from '@/components/PasswordInput';
import GoogleLoginButton from '@/components/GoogleLoginButton';
import AuthContainer from '@/components/AuthContainer';
import { useAuth } from '@/hooks/auth/useAuth';
import useForm from './useForm';

const Login = () => {
  const { isAuthenticated } = useAuth();
  const { onSubmit, isPending, validationErrors } = useForm();

  if (isAuthenticated()) return <Navigate to="/painel/agendas" replace />;

  return (
    <AuthContainer
      title="Bem-vindo(a)"
      subtitle="Acesse sua conta para gerenciar seus eventos"
    >
      <form onSubmit={onSubmit}>
        <Stack gap="5">
          <Field.Root invalid={!!validationErrors?.email}>
            <Field.Label>E-mail</Field.Label>
            <InputGroup startElement={<LuMail />} width="full" gap={0}>
              <Input name="email" type="email" placeholder="exemplo@email.com" variant="subtle" bg="gray.200" required />
            </InputGroup>
            {validationErrors?.email?.map((error, index) => (
              <Field.ErrorText key={index}>{error}</Field.ErrorText>
            ))}
          </Field.Root>
          <Field.Root invalid={!!validationErrors?.password}>
            <Field.Label>Senha</Field.Label>
            <InputGroup startElement={<LuLock />} width="full" gap={0}>
              <PasswordInput name="password" placeholder="••••••••" variant="subtle" bg="gray.200" required />
            </InputGroup>
            {validationErrors?.password?.map((error, index) => (
              <Field.ErrorText key={index}>{error}</Field.ErrorText>
            ))}
          </Field.Root>

          <HStack justify="flex-end">
            <Link asChild color="fg.muted" fontSize="sm">
              <RouterLink to="/esqueci-senha">
                Esqueci a senha
              </RouterLink>
            </Link>
          </HStack>
          <Stack gap="4">
            <Button type="submit" loading={isPending} disabled={isPending}>
              Entrar
            </Button>
            <GoogleLoginButton />
          </Stack>

          <Text textStyle="sm" color="primary.500" textAlign="center">
            Não tem uma conta?
            {' '}
            <Link asChild color="secondary.500" textDecoration="underline" fontWeight={500}>
              <RouterLink to="/cadastro">
                Cadastre-se
              </RouterLink>
            </Link>
          </Text>
        </Stack>
      </form>
    </AuthContainer>
  );
};

export default Login
